import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.href ? `https://www.kaiyuansports.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.name}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{item.name}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
}